
import { defineComponent, PropType } from 'vue'
import { mapState } from 'vuex'
import { Repository, RepositoryMetricValue } from '~/types/types'
import RunMetricStat from './RunMetricStat.vue'

export default defineComponent({
  name: 'RunMetricCard',
  components: {
    RunMetricStat
  },
  props: {
    metricsCaptured: {
      type: Array as PropType<RepositoryMetricValue[]>,
      required: true
    },
    isInModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('repository/detail', {
      repository: (state: any) => state.repository as Repository
    }),
    canSuppressMetric(): boolean {
      return Boolean(this.repository?.userPermissionMeta?.can_ignore_failing_metrics)
    },
    tooltipText(): string {
      return `Compared to ${this.repository.defaultBranchName}`
    }
  }
})
